import { SET_ACCOUNT, UPDATE_ACCOUNT } from 'constants/ActionTypes'
import { createAction } from 'redux-actions'

export const setAccount = createAction(SET_ACCOUNT, payload => payload)

export const updateAccount = createAction(UPDATE_ACCOUNT, payload => payload)
